import { Head } from "vite-react-ssg";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Navbar from "@/components/landing/Navbar";
import Footer from "@/components/landing/Footer";
import { BLOG_ARTICLES } from "@/content/blog";
import NotFound from "./NotFound";

const fmtDate = (iso: string) =>
  new Date(iso + "T00:00:00").toLocaleDateString("fr-FR", { day: "numeric", month: "long", year: "numeric" });

const BlogPost = () => {
  const { slug } = useParams<{ slug: string }>();
  const article = BLOG_ARTICLES.find((a) => a.slug === slug);
  if (!article) return <NotFound />;

  return (
    <div className="min-h-screen" style={{ background: "#ffffff" }}>
      <Head>
        <title>{`${article.title} — Blog CoachOS`}</title>
        <meta name="description" content={article.description} />
        <link rel="canonical" href={`https://www.coach-os.eu/blog/${article.slug}`} />
        <meta property="og:title" content={article.title} />
        <meta property="og:description" content={article.description} />
        <meta property="og:type" content="article" />
        <meta property="og:image" content={article.cover} />
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "BlogPosting",
            headline: article.title,
            description: article.description,
            datePublished: article.date,
            author: { "@type": "Organization", name: "CoachOS" },
            mainEntityOfPage: `https://www.coach-os.eu/blog/${article.slug}`,
          })}
        </script>
      </Head>
      <Navbar />
      <main className="container max-w-3xl pt-32 pb-24">
        <Link to="/blog" className="inline-flex items-center gap-1.5 text-sm text-[#0e1220]/50 transition-colors hover:text-[#0e1220] mb-8">
          <ArrowLeft className="w-4 h-4" /> Tous les articles
        </Link>
        <p className="text-sm text-[#0e1220]/40 mb-3">
          {fmtDate(article.date)} · {article.readingMinutes} min de lecture
        </p>
        <h1 className="text-3xl md:text-[2.6rem] font-extrabold tracking-tighter leading-tight text-[#0e1220] mb-8">
          {article.title}
        </h1>
        <img src={article.cover} alt={article.coverAlt} className="w-full rounded-2xl border border-[#e7e9f1] mb-10" loading="eager" />
        <article
          className="blog-prose"
          // Contenu interne du registre (pas de saisie utilisateur)
          dangerouslySetInnerHTML={{ __html: article.html }}
        />
        <div className="mt-14 rounded-2xl border border-[#e7e9f1] bg-white shadow-[0_1px_3px_rgba(16,20,40,0.05)] p-8">
          <h2 className="text-xl font-bold text-[#0e1220] mb-2">Essayez CoachOS</h2>
          <p className="text-[#0e1220]/55 mb-5">Programmes, suivi, nutrition et relances automatiques — mise en route en 10 minutes, sans engagement.</p>
          <Link to="/#pricing" className="inline-flex h-11 items-center rounded-full bg-[#14142B] px-6 font-semibold text-white shadow-[0_8px_20px_rgba(20,20,43,0.16)] transition hover:bg-[#23233d]">
            Voir les offres
          </Link>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default BlogPost;
